<div
  class="attribute-editor-component"
  rvSpinner="slides-editor-loader"
  [rvShowSpinner]="spinner"
>
  @if (provider === 'google' && fileId) {
    <!-- Connected account + selected file (Google Drive path) -->
    <div class="attribute-editor-row connected-file-row">
      <div class="row">
        <div class="col-xs-12">
          <div class="provider-connected-container form-group">
            <div class="account-info">
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/c/c1/Google_%22G%22_logo.svg"
                alt="Google"
                class="account-logo"
              />
              <span class="account-email">{{ componentAccountUsername }}</span>
            </div>
            <div class="provider-connected-file-info">
              <div class="file-details tw-gap-[16px]">
                <mat-icon
                  aria-hidden="true"
                  svgIcon="component-slides"
                  class="large"
                ></mat-icon>
                <div class="file-text tw-leading-[20px]">
                  <span
                    class="file-title !tw-m-0 tw-text-[14px] tw-font-semibold tw-leading-[20px] tw-text-gray-900"
                    >{{ fileName }}</span
                  >
                  @if (assetCount) {
                    <span class="file-item-count">{{ assetCount }} slides</span>
                  }
                </div>
              </div>
              <button
                class="btn btn-icon pr-0 file-options-trigger"
                [ngClass]="{ clicked: isDropdownOpen }"
                mat-icon-button
                type="button"
                aria-label="File options"
                [matMenuTriggerFor]="slidesFileMenu"
                (menuOpened)="onDropdownOpen()"
              >
                <mat-icon
                  aria-hidden="true"
                  class="file-options-icon"
                  svgIcon="more-horizontal"
                ></mat-icon>
              </button>
              <mat-menu
                #slidesFileMenu="matMenu"
                class="!tw-w-[256px] !tw-min-w-[256px]"
                xPosition="after"
                (closed)="onDropdownClose()"
              >
                <button mat-menu-item (click)="changeFile()">
                  <streamline-icon
                    aria-hidden="true"
                    class="mr-3 streamline-component-icon"
                    name="fileInverted"
                    width="16"
                    height="16"
                  ></streamline-icon>
                  <span>Change file</span>
                </button>
                <hr class="m-2" />
                <button mat-menu-item (click)="switchSource()">
                  <mat-icon
                    aria-hidden="true"
                    svgIcon="switch"
                    class="small mr-3"
                  ></mat-icon>
                  <span>Switch source</span>
                </button>
              </mat-menu>
            </div>
          </div>
        </div>
      </div>
      @if (fileAccessFailed) {
        <p class="help-block text-danger tw-mt-[8px]">
          We can't access this file. It may have been moved, deleted, or you no
          longer have permission to view it.
        </p>
      } @else if (conversionError) {
        <p class="help-block text-danger tw-mt-[8px]">{{ conversionError }}</p>
      }
    </div>
  } @else {
    <!-- Public URL (default) + "Select from Google Drive" -->
    <div class="attribute-editor-row tw-flex tw-flex-col tw-gap-[16px]">
      <span
        class="tw-block tw-text-[14px] tw-font-semibold tw-leading-[20px] tw-text-gray-900"
        >Connect your Google Slides</span
      >
      <form>
        <div
          class="form-group has-feedback !tw-mb-0 tw-flex tw-flex-col tw-gap-[8px]"
          [ngClass]="{
            'has-error': validationResult && validationResult !== 'VALID',
            'has-success': validationResult === 'VALID' && src !== '',
          }"
        >
          <label
            class="control-label !tw-m-0 tw-text-[14px] tw-font-normal tw-leading-[20px] tw-text-gray-900"
            for="te-slides-src"
            >Public URL</label
          >
          <div class="slides-url-input">
            <input
              type="text"
              id="te-slides-src"
              name="te-slides-src"
              class="form-control u_ellipsis"
              [(ngModel)]="src"
              placeholder="Enter URL"
              (input)="onSrcInput()"
              (debounceEvent)="saveSrc(srcUserEdited)"
            />
            <streamline-icon
              class="overlay-icon form-control-feedback"
              aria-hidden="true"
              name="{{
                validationResult && validationResult !== 'VALID'
                  ? 'exclamation'
                  : 'checkmark'
              }}"
              width="14"
              height="12"
            ></streamline-icon>
          </div>
          @if (validationResult && validationResult !== 'VALID') {
            <p class="help-block !tw-m-0">
              @switch (validationResult) {
                @case ('DELETED') {
                  <span
                    >Your Google Slideshow is no longer accessible, please check
                    if it's been deleted.</span
                  >
                }
                @case ('NOT_PUBLIC') {
                  <span
                    >This presentation needs sign-in, so we can't play it from a
                    link. Select it from Google Drive instead, or share it with
                    "Anyone with the link".</span
                  >
                }
                @case ('INVALID') {
                  <span>Please provide a valid Google Slides URL.</span>
                }
              }
            </p>
          }
        </div>
      </form>
      <div class="tw-flex tw-flex-col tw-gap-[16px]">
        <div class="tw-flex tw-items-center tw-gap-[10px]">
          <hr class="tw-flex-1 tw-m-0" />
          <span
            class="tw-text-[13px] tw-leading-[16px] tw-font-normal tw-text-gray-500"
            >or</span
          >
          <hr class="tw-flex-1 tw-m-0" />
        </div>
        <button
          type="button"
          matButton="outlined"
          class="tw-w-full button-role--provider"
          (click)="selectFromDrive()"
          [disabled]="driveConnecting"
        >
          <mat-icon aria-hidden="true" svgIcon="integration-google"></mat-icon>
          <span>Select from Google Drive</span>
          @if (driveConnecting) {
            <mat-spinner
              diameter="16"
              class="tw-absolute tw-right-[12px] tw-top-1/2 tw--translate-y-1/2"
            ></mat-spinner>
          }
        </button>
        @if (driveError) {
          <p class="help-block text-danger !tw-m-0">
            We couldn't connect to Google Drive. Try again.
          </p>
        }
        <p
          class="help-block !tw-m-0 tw-text-[13px] tw-leading-[16px] tw-text-gray-600"
        >
          Slides show as static images, without transitions or animations.
        </p>
      </div>
    </div>
  }

  <div class="attribute-editor-row">
    <span
      class="tw-block tw-mt-[24px] tw-mb-4 tw-text-2xl tw-font-semibold tw-text-gray-900"
      >Settings</span
    >
    <div class="tw-flex tw-items-center tw-gap-3">
      <label
        class="tw-flex-1 tw-m-0 tw-text-2xl tw-font-normal tw-text-gray-900"
        for="te-slides-duration"
        >Show each slide for</label
      >
      <mat-form-field
        appearance="outline"
        class="tw-flex-1"
        subscriptSizing="dynamic"
      >
        <input
          matInput
          type="number"
          id="te-slides-duration"
          name="te-slides-duration"
          min="1"
          [(ngModel)]="duration"
          placeholder="10"
          (change)="saveDuration()"
        />
        <span matTextSuffix>Seconds</span>
      </mat-form-field>
    </div>
  </div>
</div>
